import React, { useState, useEffect } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../config/contact';

const FOOTER_COLUMNS = [
  {
    title: 'Descubra Vekian',
    links: [
      { text: 'Quiénes Somos', path: '/nosotros' },
      { text: 'Servicios', path: '/servicios' },
      { text: 'Proyectos', path: '/proyectos' },
      { text: 'Contacto', path: '/contacto' },
    ],
  },
  {
    title: 'Servicios',
    links: [
      { text: 'Soluciones Cloud', path: '/servicios/cloud' },
      { text: 'Analítica de Datos', path: '/servicios/data' },
      { text: 'Diseño UX/UI', path: '/servicios/design' },
      { text: 'Ingeniería de Software', path: '/servicios/ingenieria' },
      { text: 'Desarrollo Frontend', path: '/servicios/frontend' },
      { text: 'Estrategia de Innovación', path: '/servicios/innovacion' },
    ],
  },
  {
    title: 'Industrias',
    links: [
      { text: 'Automotriz', path: '/industrias/automotriz' },
      { text: 'Banca', path: '/industrias/banca' },
      { text: 'Mercados de Capital', path: '/industrias/mercados-capital' },
      { text: 'Bienes de Consumo', path: '/industrias/bienes-consumo' },
      { text: 'Energía', path: '/industrias/energia' },
      { text: 'Salud y Ciencias de la Vida', path: '/industrias/salud' },
      { text: 'Seguros', path: '/industrias/seguros' },
      { text: 'Manufactura', path: '/industrias/manufactura' },
      { text: 'Medios', path: '/industrias/medios' },
      { text: 'Tecnología', path: '/industrias/tecnologia' },
      { text: 'Petróleo y Gas', path: '/industrias/petroleo' },
      { text: 'Retail', path: '/industrias/retail' },
    ],
  },
];

const SOCIAL_LINKS = [
  { label: 'Facebook', href: 'https://facebook.com/vekianlabs', icon: faFacebookF },
  { label: 'Twitter', href: 'https://twitter.com/vekianlabs', icon: faTwitter },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/vekianlabs', icon: faLinkedinIn },
  { label: 'Instagram', href: 'https://instagram.com/vekianlabs', icon: faInstagram },
];

function Footer() {
  const [showScroll, setShowScroll] = useState(false);

  const scrollTop = () => {
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      setShowScroll(window.pageYOffset > 400);
    };

    window.addEventListener('scroll', checkScrollTop, { passive: true });
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  return (
    <footer className='vfoot'>
      <div className='vfoot-inner'>
        <div className='vfoot-intro'>
          <h2 className='vfoot-title'>
            Datos, software e innovación para construir ventaja competitiva.
          </h2>
          <p className='vfoot-description'>
            Ayudamos a empresas a transformar procesos, información y capacidades tecnológicas
            en resultados más claros, escalables y sostenibles.
          </p>
          <div className='vfoot-actions'>
            <Link to='/contacto' className='vfoot-link-strong'>Conéctese con nosotros</Link>
            <Link to='/servicios' className='vfoot-link-strong'>Ver servicios</Link>
            <a href={CONTACT_MAILTO} className='vfoot-link-strong'>{CONTACT_EMAIL}</a>
          </div>
        </div>

        <nav className='vfoot-columns' aria-label='Mapa del sitio'>
          {FOOTER_COLUMNS.map((col) => (
            <div className={`vfoot-group ${col.links.length > 8 ? 'is-wide' : ''}`} key={col.title}>
              <h3 className='vfoot-group-title'>{col.title}</h3>
              <ul>
                {col.links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>{link.text}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className='vfoot-bottom'>
          <p className='vfoot-copy'>
            Copyright © {new Date().getFullYear()} Vekian Labs. Todos los derechos reservados.
          </p>

          <ul className='vfoot-legal'>
            <li><Link to='/politica-privacidad'>Política de Privacidad</Link></li>
            <li><Link to='/terminos-de-uso'>Términos de Uso</Link></li>
          </ul>

          <p className='vfoot-place'>Quito · Ecuador · Soluciones tecnológicas para empresas</p>

          <ul className='vfoot-social'>
            {SOCIAL_LINKS.map((social) => (
              <li key={social.label}>
                <a href={social.href} target='_blank' rel='noreferrer noopener' aria-label={social.label}>
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {showScroll && (
        <button
          className='vfoot-top'
          onClick={scrollTop}
          type='button'
          aria-label='Volver arriba'
        >
          <FontAwesomeIcon icon={faChevronUp} />
        </button>
      )}
    </footer>
  );
}

export default Footer;
